import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import {setOnboardingStatus} from "../../Redux/CommonReducer";
import API from "../../Common/API";

const useOnBoarding = ({ module, tag, childCount}) => {
    const dispatch = useDispatch();

    const onboardingStatus = useSelector(state => state.module[module].common.onboarding[tag]);

    const [ currentSlide, setCurrentSlide ] = React.useState(0);
    const [ isOpen, setIsOpen ] = React.useState(false);

    useEffect(() => {
        setIsOpen(onboardingStatus === 'active');
    }, [onboardingStatus])

    const previousSlide = useCallback(() => {
        if (currentSlide > 0) {
            setCurrentSlide(currentSlide - 1);
        }
    }, [currentSlide]);

    const nextSlide = useCallback(() => {
        if (currentSlide < (childCount - 1)) {
            setCurrentSlide(currentSlide + 1);
        }
    }, [currentSlide, childCount]);

    const toggleOpen = useCallback((value) => {
        setIsOpen(value);
        setCurrentSlide(0);
    }, []);

    const handleSkip = useCallback(() => {
        toggleOpen(false);

        dispatch(setOnboardingStatus(tag, 'ignored'));

        axios.post(
            API.getUrl(module, `onboarding/${tag}/ignore`),
            { tag }
        ).catch(e => console.error(e));
    }, [dispatch, tag, module, toggleOpen]);

    const handleComplete = useCallback(() => {
        toggleOpen(false);
        dispatch(setOnboardingStatus(tag, 'complete'));

        axios.post(
            API.getUrl(module, `onboarding/${tag}/complete`),
            { tag }
        ).catch(e => console.error(e));
    }, [dispatch, tag, module, toggleOpen]);

    return {
        isOpen,
        currentSlide,
        setCurrentSlide,
        toggleOpen,
        handleSkip,
        handleComplete,
        nextSlide,
        previousSlide,
    };
}

export default useOnBoarding;
